import type { PAGE_POSITIONS } from 'types';
import type { Affiliate, Price } from 'types/capi/shared';
import type { TrackableProduct } from 'types/TrackableProduct';

import AffiliateProductLink from '~/components/AffiliateProductLink';
import { sizeSixVariants } from '~/domain/sizes';
import type { UrlTemplates } from '~/utils/tracking';

function isSelectedSize(selectedSize: string, size: string) {
  if (selectedSize === '6') return sizeSixVariants.some((s) => s === size);

  return selectedSize === size;
}

type Props = {
  affiliate: Affiliate;
  pagePosition: PAGE_POSITIONS;
  position: number;
  price: Price;
  product: TrackableProduct;
  selectedSize?: string;
  sizes: string[];
  urlTemplates: UrlTemplates;
};

const Size = ({
  isHighlighted,
  children
}: {
  children: string;
  isHighlighted: boolean;
}) => {
  return (
    <li
      className={`rounded border border-concrete px-1.5 ${
        isHighlighted ? 'bg-concrete text-grey-read' : 'text-grey-hide'
      }`}
    >
      {children}
    </li>
  );
};

const AffiliateSizes = ({
  sizes,
  selectedSize,
  pagePosition,
  position,
  affiliate,
  product,
  price,
  urlTemplates
}: Props) => {
  if (!sizes.length) return null;

  return (
    <ul
      className="flex flex-wrap justify-center gap-2 text-xs"
      data-cy="stock-listing-sizes"
    >
      <li>UK sizes:</li>
      {sizes.map((size) => (
        <AffiliateProductLink
          key={`sl-size-${size}`}
          price={price}
          affiliate={affiliate}
          product={product}
          buttonPosition={position}
          pagePosition={pagePosition}
          urlTemplates={urlTemplates}
          selectedSize={size}
          variant="none"
        >
          <Size
            isHighlighted={!selectedSize || isSelectedSize(selectedSize, size)}
          >
            {size}
          </Size>
        </AffiliateProductLink>
      ))}
    </ul>
  );
};

export default AffiliateSizes;
